import uaaApi from "../../../api/uaaConfig";

export const handleMenuConfig = (params, data, method) => {
  return uaaApi({
    method,
    url: "/api/v1/menu-config",
    params,
    data,
  });
};

export const getListMenuConfig = (params) => {
  return uaaApi({
    method: "get",
    url: "/api/v1/menu-config/list",
    params,
  });
};

export const handleMenu = (params, data, method) => {
  return uaaApi({
    method,
    url: "/api/v1/menu",
    params,
    data,
  });
};

export const getMenuList = (params) => {
  return uaaApi({
    method: "get",
    url: "/api/v1/menu/list",
    params,
  });
};

export const handleDashboard = (params, data, method) => {
  return uaaApi({
    method,
    url: "/api/v1/dashboard",
    params,
    data,
  });
};

export const getListDashboard = (params) => {
  return uaaApi({
    method: "get",
    url: "/api/v1/dashboard/list",
    params,
  });
};
